import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import React from 'react';

import { Provider } from 'react-redux';
import { store } from '@flexo/reducers';

import * as ReactDOM from 'react-dom/client';
import ResizeObserver from 'resize-observer-polyfill';
import App from './app/app';


import { TranslationsProvider } from '@flexo/translations';

window.ResizeObserver = ResizeObserver;

const ENV = (import.meta as any).env;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  // <StrictMode>
  <Provider store={store}>
    <TranslationsProvider>
      <App />
    </TranslationsProvider>
  </Provider>
  //</StrictMode> 
);
